import { useEffect, useState } from "react";

const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Selections", href: "#selections" },
  { label: "Podcast", href: "#podcast" },
  { label: "Tickets", href: "#tickets" },
  { label: "Shop", href: "#shop" },
  { label: "Gallery", href: "#gallery" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const id = href.replace("#", "");
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <nav className={`navbar${scrolled ? " scrolled" : ""}`}>
      <div className="navbar__inner">
        {/* Brand */}
        <a
          href="#home"
          className="navbar__brand"
          onClick={(e) => {
            e.preventDefault();
            handleNavClick("#home");
          }}
        >
          <img
            src="https://c3store.nyc3.digitaloceanspaces.com/mwff/Official%20MWFF%20Logo.png"
            alt="MWFF"
            className="brand-mark"
            style={{ height: "60px", width: "auto", objectFit: "contain" }}
          />
          <span className="brand-name">
            <span className="brand-main">Midwest Fear Fest</span>
            <span className="brand-sub">Oct 3, 2026 · Indianapolis</span>
          </span>
        </a>

        {/* Desktop Links */}
        <ul className="navbar__links">
          {NAV_LINKS.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(link.href);
                }}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* Desktop CTA */}
        <div className="navbar__cta">
          <a
            href="https://kankanindy.com/events/midwestfearfest/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            style={{ padding: "10px 22px", fontSize: "0.82rem" }}
          >
            Get Tickets
          </a>
        </div>

        {/* Hamburger */}
        <button
          className={`navbar__hamburger${menuOpen ? " open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`navbar__mobile-menu${menuOpen ? " open" : ""}`}>
        {NAV_LINKS.map((link) => (
          <a
            key={link.href}
            href={link.href}
            onClick={(e) => {
              e.preventDefault();
              handleNavClick(link.href);
            }}
          >
            {link.label}
          </a>
        ))}
        <a
          href="https://kankanindy.com/events/midwestfearfest/"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-primary"
          style={{ margin: "12px 24px 0", justifyContent: "center" }}
        >
          Get Tickets
        </a>
      </div>
    </nav>
  );
}
